import { STATUS_ORDER, STATUS_LABELS } from "@/lib/api";

export default function StatusStepper({ current, onChange, disabled }) {
  const idx = STATUS_ORDER.indexOf(current);
  return (
    <div className="w-full" data-testid="status-stepper">
      <div className="flex items-center">
        {STATUS_ORDER.map((s, i) => {
          const active = i <= idx;
          const isCurrent = i === idx;
          return (
            <div key={s} className="flex items-center flex-1 last:flex-none">
              <button
                type="button"
                disabled={disabled}
                onClick={() => onChange?.(s)}
                data-testid={`stepper-${s}`}
                className={`shrink-0 flex items-center justify-center w-8 h-8 text-xs font-bold border transition-colors ${
                  active
                    ? "bg-black text-white border-black"
                    : "bg-white text-black border-zinc-300"
                } ${isCurrent ? "ring-2 ring-offset-2 ring-black" : ""} ${
                  disabled ? "cursor-default" : "cursor-pointer hover:border-black"
                }`}
                title={STATUS_LABELS[s]}
              >
                {i + 1}
              </button>
              {i < STATUS_ORDER.length - 1 && (
                <div className={`stepper-line mx-2 ${i < idx ? "active" : ""}`} />
              )}
            </div>
          );
        })}
      </div>
      <div className="grid grid-cols-7 gap-2 mt-3 text-[10px] uppercase tracking-wider text-zinc-500">
        {STATUS_ORDER.map((s, i) => (
          <div
            key={s}
            className={`text-center ${i === idx ? "text-black font-semibold" : ""}`}
          >
            {STATUS_LABELS[s]}
          </div>
        ))}
      </div>
    </div>
  );
}
